module.exports = __webpack_public_path__ + "img/ROU.8e6fd09a.svg";